import { render, staticRenderFns } from "./judicial-status-select.vue?vue&type=template&id=0e0d4cd4"
import script from "./judicial-status-select.vue?vue&type=script&lang=js"
export * from "./judicial-status-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e0d4cd4')) {
      api.createRecord('0e0d4cd4', component.options)
    } else {
      api.reload('0e0d4cd4', component.options)
    }
    module.hot.accept("./judicial-status-select.vue?vue&type=template&id=0e0d4cd4", function () {
      api.rerender('0e0d4cd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/invoice/components/selects/judicial-status-select.vue"
export default component.exports